import { Label } from 'components/ui/label';
import { Switch } from 'components/ui/switch';
import { ColorPicker } from 'components/Inputs/ColorPicker';
import { MultiColorPicker } from 'components/Inputs/MultiColorPicker';
import { PaddingControls } from 'components/Inputs/PaddingControls';
import { useChartConfig } from 'hooks/useChartConfig';

export const AppearanceForm = () => {
  const {
    chart: {
      type,
      props: { color, colors, padding, isRTL },
    },
    updateChartProps,
  } = useChartConfig();

  return (
    <div>
      <form className="flex flex-col gap-2">
        <div>
          {type === 'scatter' ? (
            <>
              <h3 className="mb-2">Couleur personnalisée</h3>
              <ColorPicker
                defaultColor={color}
                onChange={(color) => {
                  updateChartProps({
                    color,
                  });
                }}
              />
            </>
          ) : (
            <>
              <h3 className="mb-2">Couleurs personnalisées</h3>
              <MultiColorPicker
                defaultColors={colors}
                onChange={(colors) => {
                  updateChartProps({
                    colors,
                  });
                }}
              />
            </>
          )}
        </div>
        <div>
          <h3 className="mt-2">Espacement</h3>
          <PaddingControls
            defaultPaddings={
              padding || { top: 0, bottom: 0, left: 0, right: 0 }
            }
            onChange={(padding) => {
              updateChartProps({
                padding,
              });
            }}
          />
        </div>
        <div className="my-2">
          <h3 className="mb-2">Direction</h3>
          <div className="flex items-center space-x-2">
            <Switch
              id="rtl-toggle"
              checked={isRTL}
              onCheckedChange={(isEnabled) =>
                updateChartProps({ isRTL: isEnabled })
              }
            />
            <Label htmlFor="rtl-toggle" className="cursor-pointer">
              De droite à gauche
            </Label>
          </div>
        </div>
      </form>
    </div>
  );
};
